const sentryConfig = {
  dsn: "https://fd718325cde14ccebd0833f62e104399@o234395.ingest.sentry.io/5757378",
  tracesSampleRate: 0,
  environment: "dev",
  release: "19ae2b53ea6602380e7c0f028d40f6cb0b9642ff-Ubuntu7Standard:0d33bf78-93e4-4967-822c-a8022b0748b7",
};

export default sentryConfig;
